'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
  FeatureControl

  Access feature control property as a singleton instance.
  Any method should only be invoked after account data model being created.

  Parameters:
    presenter [APIPresenter] (required):
      Reference to the APIPresenter in order to communicate with SOA and create data models.

*/

function FeatureControl(presenter) {
  this._presenter = presenter;
  // this._localValues can be used in 2 cases:
  // 1. setup web only feature flags for show/hide certain UI
  // 2. set a default value to certain feature when BE omit it and we don't want it to be true by default.
  // e.g. this._localValues = {SpendingAnalysis: false}; For the scenario that BE didn't set this feature but somehow we don't want to display it by default
  this._localValues = {};

  this.isEnabled = function (featureName) {
    var feat = this._presenter.getModelProperty('account.feature_controls.' + featureName);
    return feat === undefined ? true : feat === true;
  };

  // Inject local FeatureControl values to account.feature_controls property. Note: it WON'T override any existing values.
  this.injectLocalValues = function () {
    var features = this._presenter.getModelProperty('account.feature_controls');
    var mergedFeatures = _extends(this._localValues, features);
    this._presenter.setModelProperty('account.feature_controls', mergedFeatures);
  };
}